import styled from "@emotion/styled";

export const StyledContainer = styled.button<{ $inlineBlock?: boolean }>`
  ${({ $inlineBlock }) => $inlineBlock && `display: inline-block;`}
  height: 16px;
  padding: 0;
`;

export const StyledChipWrapper = styled.div<{ $inlineBlock?: boolean }>`
  ${({ $inlineBlock }) => $inlineBlock && `display: inline-block;`}
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  padding-left: 4px;
  padding-right: 3px;
  border-radius: 4px;
`;

export const StyledCollectionChipOverflow = styled.span<{ $inlineBlock?: boolean }>`
  ${({ $inlineBlock }) => $inlineBlock && `display: inline-block;`}
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  padding-left: 4px;
  padding-right: 3px;
  border-radius: 4px;
  margin-right: 7px;
  color: ${({ theme }) => theme.colors.text.secondary};
  background-color: ${({ theme }) => theme.colors.background.badge.default};
  cursor: pointer;
`;
